import React from "react";
import { cn } from "@/lib/utils";
import type { CampaignContactStatus } from "@/model/interface/CampaignContact";

const TONE_BY_STATUS: Record<string, string> = {
  QUEUED: "bg-muted-foreground/40",
  DIALING: "bg-warning animate-pulse",
  RINGING: "bg-warning animate-pulse",
  ANSWERED: "bg-success",
  CONNECTED: "bg-success animate-pulse",
  ON_HOLD: "bg-warning",
  COMPLETED: "bg-muted-foreground/60",
  NO_ANSWER: "bg-muted-foreground/60",
  SKIPPED: "bg-muted-foreground/60",
  SUPPRESSED: "bg-muted-foreground/60",
  CANCELED: "bg-muted-foreground/60",
  VOICEMAIL: "bg-warning",
  ABANDONED: "bg-destructive",
  BUSY: "bg-destructive",
  FAILED: "bg-destructive",
};

export function StatusDot({ status }: { status: CampaignContactStatus }) {
  return (
    <span className={cn("h-2.5 w-2.5 rounded-full shrink-0", TONE_BY_STATUS[status] ?? "bg-muted-foreground/60")} />
  );
}
